import React from 'react'
import { Link } from 'gatsby'
import {
  Intro,
  Layout,
  SectionTitle,
  Showcase,
  Header,
} from '../../../../components'

import './style.scss'
import data from './data.json'
import changelog from '../../../../data/changelog.json'

export default () => {
  return (
    <>
      <Header
        site={data.site}
        slug={data.slug + '/design/'}
        state="design"
        title={data.title}
      />
      <Layout
        category={data.category}
        changelog={changelog[data.title].changelog}
        site={data.site}
        slug={data.slug + '/design/'}
        state="design"
        title={data.title}
        updated={changelog[data.title].lastUpdated}
      >
        <Intro>
          <p>
            In most contexts, links will navigate the user to a new page. They
            can also toggle between different layouts for displaying data or
            bring up a contextual help message. Link text is styled specifically
            so it will stand out from standard text content.
          </p>
        </Intro>
        <SectionTitle>Usage</SectionTitle>{' '}
        <p>
          Avoid text wrapping links wherever possible. If the linked action will
          allow the user to change data or navigate to the next screen in a
          flow, use a{' '}
          <Link
            className="link"
            to={'/' + data.site + '/components/button/design'}
          >
            button
          </Link>{' '}
          instead.{' '}
        </p>
        <Showcase
          site={data.site}
          title="Link"
          text="In addition to the default state, links also have a hover state and a focus state. All states allow the user to recognize that they can use the link to take action."
          code={code.link}
        >
          <a href="#/" class="c-link u-type--center">
            Click Here
          </a>
        </Showcase>
        <Showcase
          site={data.site}
          title="Icon Link"
          text={
            <div>
              <p>
                Text links can appear with associated icons, such as the
                question mark on help links or the map pin on location links.
                The icon is interactive and forms part of the navigation. It
                will have the same states as a text link. Refer to our{' '}
                <Link
                  class="link"
                  to={'/' + data.site + '/guidelines/iconography/design'}
                >
                  icon library
                </Link>{' '}
                for available icons.
              </p>
              <p>
                Icon links are available in three different sizes, small (12px)
                for captions and less prominent actions, medium (16px) for links
                in body content, and large (24px) for links that appear in
                larger text content.
              </p>
            </div>
          }
          code={code.link}
        >
          <a href="#/" class="c-icon-link">
            <i class="icon icon--info c-icon-link__icon"></i>Click Here
          </a>
        </Showcase>
        <hr />
        <SectionTitle>Design Environment</SectionTitle>
        <p>
          Link assets are available at the 16px size when used in body copy and
          at the 12px size when used to trigger contextual help. Choose the size
          that is appropriate for your layout needs.
        </p>
        <hr />
        <SectionTitle>Microcopy</SectionTitle>
        <p>
          Like buttons, links should use strong verbs and specific language to
          clearly signal what will happen next. Do not use "here" or "click
          here" in the link text. Keep text as short as possible to prevent
          wrapping. In inline text, limit the link text to only the most
          relevant part of the sentence - aim for 3-5 words. Only include ending
          punctuation in the link if it is a standalone.
        </p>
      </Layout>
    </>
  )
}

export const code = {
  /*
  link: `<a href="" class="c-link">Click Here</a>
`,*/
}
